import { AppNotification, Bank, CarOutline, Cash, Gift, Group, HeadsetHelp, RefreshDouble, Reports, Settings } from 'iconoir-react'
import { NavLink } from 'react-router-dom'
import { logo } from '../../assets/index'

const SideBar = ({ page }) => {
  const isActive = (path) => page?.includes(path);

  const NavItem = ({ to, icon: Icon, label, path }) => (
    <li className="relative">
          <NavLink
        to={to}
        className={`flex items-center gap-3 px-4 py-3 mx-3 rounded-xl text-sm font-medium transition-all duration-200 group
          ${isActive(path)
            ? 'bg-gradient-to-r from-primary-500/10 to-primary-500/5 text-primary-700'
            : 'text-surface-500 hover:bg-surface-100 hover:text-surface-700'
          }`}
      >
        {isActive(path) && (
          <span className='absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-gradient-to-b from-primary-500 to-primary-600 rounded-r-full' />
        )}
        <span className={`w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-200
          ${isActive(path)
            ? 'bg-primary-500 text-white shadow-glow'
            : 'bg-surface-100 text-surface-500 group-hover:bg-primary-100 group-hover:text-primary-600'
          }`}>
          <Icon strokeWidth={2} className="w-5 h-5" />
        </span>
        <span className="font-medium">{label}</span>
          </NavLink>
        </li>
  );

  const NavSection = ({ title, children }) => (
    <div className="mt-6">
      <p className="px-6 mb-3 text-[10px] font-bold text-surface-400 uppercase tracking-widest">{title}</p>
      <ul className="space-y-1">
        {children}
      </ul>
    </div>
  );

  return (
    <aside className='col-span-2 flex flex-col h-full bg-white border-r border-surface-100'>
      {/* Logo Header */}
      <div className='flex items-center gap-3 px-6 py-5 border-b border-surface-100'>
        <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary-500 to-primary-700 flex items-center justify-center shadow-glow">
          <img alt='logo' src={logo} className="w-7 h-7 object-contain" />
        </div>
        <div>
          <h1 className='font-bold text-surface-800 text-lg leading-tight'>WayRide</h1>
          <p className='text-xs text-surface-400 font-medium'>Admin Dashboard</p>
        </div>
      </div>

      {/* Navigation */}
      <nav className='flex-grow overflow-y-auto scrollbar-thin py-4'>
        <NavSection title="Activities">
          <NavItem to="/analytics" icon={Reports} label="Analytics" path="/analytics" />
          <NavItem to="/transactions" icon={Bank} label="Transactions" path="/transactions" />
          <NavItem to="/refunds" icon={RefreshDouble} label="Refunds" path="/refunds" />
          <NavItem to="/trips" icon={CarOutline} label="Trips" path="/trips" />
          <NavItem to="/notifications" icon={AppNotification} label="Notifications" path="/notifications" />
          <NavItem to="/payment-methods" icon={Cash} label="Payments" path="/payment-methods" />
        </NavSection>

        <NavSection title="Management">
          <NavItem to="/vehicles" icon={CarOutline} label="Vehicles" path="/vehicles" />
          <NavItem to="/promotions" icon={Gift} label="Promotions" path="/promotions" />
        </NavSection>

        <NavSection title="People">
          <NavItem to="/admins" icon={Group} label="Admins" path="/admins" />
          <NavItem to="/users" icon={Group} label="Users" path="/users" />
        </NavSection>
      </nav>

      {/* Bottom Section */}
      <div className='border-t border-surface-100 p-4 space-y-1'>
        <NavLink
          to="/settings"
          className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 
            ${isActive('/settings')
              ? 'bg-surface-100 text-surface-700'
              : 'text-surface-500 hover:bg-surface-100 hover:text-surface-700'
            }`}
        >
          <span className="w-9 h-9 rounded-xl bg-surface-100 flex items-center justify-center">
            <Settings strokeWidth={2} className="w-5 h-5" />
          </span>
          <span>Settings</span>
        </NavLink>

        <NavLink
          to="/support"
          className={`flex items-center gap-3 px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200 
            ${isActive('/support')
              ? 'bg-accent-50 text-accent-700'
              : 'text-surface-500 hover:bg-accent-50 hover:text-accent-700'
            }`}
        >
          <span className={`w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-200
            ${isActive('/support')
              ? 'bg-accent-500 text-white shadow-glow-accent'
              : 'bg-accent-100 text-accent-600'
            }`}>
            <HeadsetHelp strokeWidth={2} className="w-5 h-5" />
          </span>
          <span>Support</span>
          <span className="ml-auto bg-accent-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full animate-pulse-slow">
            LIVE
          </span>
        </NavLink>
      </div>
    </aside>
  )
}

export default SideBar
